import React from "react";
import Image from "../../Tags/Image";
import { useCaptureEvent } from "../../../hooks/useCaptureEvent";

export default function CompanySocialMedia({ company, miniView }) {
  const captureEvent = useCaptureEvent();
  return (
    <div className="flex space-x-4 items-center">
      {company?.social_media_urls?.linkedin && miniView && (
        <a
          href={company?.social_media_urls?.linkedin?.url}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => {
            captureEvent("EXC_Company_SocialMediaBtn", {
              link_type: "Linkedin",
            });
          }}
        >
          <Image className="no-invert" src="/images/ext/linkedin.svg" alt={`logo`} height={22} style={{ maxHeight: 22 }} />
        </a>
      )}

      {!miniView && company?.social_media_urls?.linkedin && (
        <a
          href={company?.social_media_urls?.linkedin?.url}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => {
            captureEvent("EXC_Company_SocialMediaBtn", {
              link_type: "Linkedin",
            });
          }}
        >
          <Image className="no-invert" src="/images/ext/linkedin.svg" alt={`logo`} height={22} style={{ maxHeight: 22 }} />
        </a>
      )}
      {company?.social_media_urls?.facebook && (
        <a
          href={company?.social_media_urls?.facebook.url}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => {
            captureEvent("EXC_Company_SocialMediaBtn", {
              link_type: "Facebook",
            });
          }}
        >
          <Image className="no-invert" src="/images/ext/facebook.svg" alt={`logo`} height={22} style={{ maxHeight: 22 }} />
        </a>
      )}
      {company?.social_media_urls?.github && (
        <a
          href={company?.social_media_urls?.github.url}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => {
            captureEvent("EXC_Company_SocialMediaBtn", {
              link_type: "Github",
            });
          }}
        >
          <Image className="no-invert" src="/images/ext/github.svg" alt={`logo`} height={22} style={{ maxHeight: 22 }} />
        </a>
      )}
      {company?.social_media_urls?.twitter && (
        <a
          href={company?.social_media_urls?.twitter.url}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => {
            captureEvent("EXC_Company_SocialMediaBtn", {
              link_type: "X",
            });
          }}
        >
          <Image className="no-invert" src="/images/ext/x.svg" alt={`logo`} height={22} style={{ maxHeight: 22 }} />
        </a>
      )}
    </div>
  );
}
